// @ts-nocheck
// import Control from 'react-leaflet-control';
import '@geoman-io/leaflet-geoman-free';
import { useLeafletContext } from '@react-leaflet/core';
import L from 'leaflet';
import 'leaflet-toolbar';
import { useEffect } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import Icon from 'utility/icomoon';

export interface TrajectoryToolbarOptions {
  useToolbar: boolean;
  showTrajectory?: bool;
  setShowTrajectory?: Function;
  listenMapControlChanges?: any[];
  position?: 'topleft' | 'topright' | 'bottomleft' | 'bottomright';
}

/* -------------------------------------------------------------------------- */
/*                       ToolbarUnitTrajectoryControl                         */
/* -------------------------------------------------------------------------- */

const ToolbarUnitTrajectoryControl = (props: TrajectoryToolbarOptions) => {
  const {
    useToolbar,
    showTrajectory,
    setShowTrajectory,
    position = 'topleft',
    listenMapControlChanges
  } = props;

  const context = useLeafletContext();
  const intl = useIntl();

  const { store } = useSelector((state) => ({
    store: state
  }));

  useEffect(() => {
    const container = context.layerContainer || context.map;
    try {
      var ImmediateSubAction = L.Toolbar2.Action.extend({
        initialize: function (map, myAction) {
          this.map = map;
          this.myAction = myAction;
          L.Toolbar2.Action.prototype.initialize.call(this);
        },
        addHooks: function () {
          this.myAction.disable();
        }
      });

      var trajectory = L.Toolbar2.Action.extend({
        options: {
          toolbarIcon: {
            tooltip: showTrajectory
              ? intl.formatMessage({ id: 'map.trajectoryToolbar.tooltipDisableTrajectory' })
              : intl.formatMessage({ id: 'map.trajectoryToolbar.tooltipEnableTrajectory' }),
            html: ReactDOMServer.renderToStaticMarkup(
              <>
                {showTrajectory ? (
                  <Icon size={18} icon="Alert-503" color={'#8ace00'} />
                ) : (
                  <Icon size={18} icon="Alert-503" />
                )}
              </>
            )
          }
        },
        addHooks: () => {
          if (showTrajectory) {
            setShowTrajectory(false);
          } else {
            setShowTrajectory(true);
          }
        },
        disable: function (e) {
          L.Toolbar2.Action.prototype.disable.call(this);
        }
      });

      L.Toolbar2.TrajectoryToolbar = L.Toolbar2.Control.extend({
        options: {
          actions: [trajectory]
        }
      });

      var trajectoryToolbar = new L.Toolbar2.TrajectoryToolbar({ position: position });
      trajectoryToolbar.addTo(container);

      return () => {
        trajectoryToolbar.remove();
      };
    } catch {}
  }, [...listenMapControlChanges]);
  return null;
};

ToolbarUnitTrajectoryControl.defaultProps = {
  postion: 'topleft',
  showTrajectory: false,
  setShowTrajectory: () => null,
  listenMapControlChanges: []
};

export default ToolbarUnitTrajectoryControl;
